/* eslint-disable */
export default {
  toolTip: 'Ver en{crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
